import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { deCommonCurrentPartnerSelector } from 'src/store/commonPart/selector';
import { store } from 'src/store/store';

/** change the title of the page (react-helmet ?) */
export const changePageTitle = (str: string): void => {
  if (process.env.NODE_ENV === 'test') {
    document.title = str;
  } else {
    document.title = `${str} | ${deCommonCurrentPartnerSelector(store.getState()).Name}`;
  }
};

/**
 * change document title as a hook
 */
export const usePageTitle = (titleKey: string | string[], noTranslation = false): void => {
  const { t } = useTranslation();

  useEffect(() => {
    if (noTranslation) {
      changePageTitle(Array.isArray(titleKey) ? titleKey.join('') : titleKey);
    } else {
      changePageTitle(Array.isArray(titleKey) ? titleKey.map(t).join('') : t(titleKey));
    }
  }, [noTranslation, t, titleKey]);
};

export const useNsPageTitle = (ns: string, titleKey: string): void => {
  const { t } = useTranslation(ns);

  useEffect(() => {
    changePageTitle(t(titleKey));
  }, [t, titleKey]);
};
